import { LoadingButtonProps, LoadingButton as MuiLoadingButton } from "@mui/lab"

const LoadingButton = ({ ...rest }: LoadingButtonProps) => {
  return (
    <MuiLoadingButton variant={rest.variant || "contained"} color="secondary" {...rest}>
      {rest.children}
    </MuiLoadingButton>
  )
}

export default LoadingButton
